import { flatMap, has } from "lodash";
import { useReducer } from "react";
import toast from "react-hot-toast";
import api from "../../apis/axiosInterceptor";

interface Master {
  allWeeks: any;
  importLogData: any;
  currentWeekData?: any;
  error: string;
}

const initialArgs: Master = {
  allWeeks: [],
  importLogData: [],
  currentWeekData: undefined,
  error: "",
};

const reducer = (state: Master, action: Master) => {
  return { ...state, ...action };
};

const useWeekSetting = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getCurrentWeek = async () => {
    try {
      const result: any = await api.get(`/api/team/current-week`);

      if (result.data.status) {
        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const getAllWeeks = async () => {
    try {
      const currentWeekData = await getCurrentWeek();
      const result: any = await api.get(`/api/activity/get-week`);

      if (result.data.status) {
        setState({
          ...state,
          allWeeks: result.data.data,
          currentWeekData: currentWeekData,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const updateWeekSetting = async (formData: FormData) => {
    /* const paramObj = {
      week,
      users,
    }; */
    try {
      const result: any = await api.patch(`/api/users/week-setting`, formData);

      if (result.data.status) {
        toast.success(result.data.message, {
          id: "updateUserToast",
        });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr, { id: "updateUserToastError" });
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message, { id: "updateUserToastError" });
      setState({ ...state, error: error.message });
      return false;
    }
  };
  /* Developer Wise Site API End*/

  const updateWeekWiseCSVFile = async (formData: FormData) => {
    try {
      const result: any = await api.patch(
        `/api/users/import-week-activity`,
        formData,
      );

      if (result.data.status) {
        toast.success(result.data.message, {
          id: "updateUserToast",
        });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr, { id: "updateUserToastError" });
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message, { id: "updateUserToastError" });
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const getUploadLogHistory = async (weekId: string) => {
    try {
      const result: any = await api.get(
        `/api/users/get-import-logs?week=${weekId}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          importLogData: result.data.data,
        });

        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  return {
    // New Code Start
    getAllWeeks,
    updateWeekSetting,
    updateWeekWiseCSVFile,
    getUploadLogHistory,
    // New Code End
    ...state,
  };
};

export default useWeekSetting;
